<template>
  <div class="login_body">
    <section>
      <div class="login_logo">
          <router-link to="/">
            <img src="../../assets/logo_white.png"/>
          </router-link>
      </div>

      <div class="login_middle_btn">
          <router-link to="/"><i class="iconfont icon-dna4"></i>进入靶点探索</router-link>
           <router-link :to="{ path:'/login',query:{id:1}}" ><i class="iconfont icon-yonghu2"></i>立即登录</router-link>
           <router-link :to="{ path:'/feedback',query:{id:1}}" ><i class="iconfont icon-yonghu2"></i>指导与反馈</router-link>
          <!--<router-link :to="{ name:'/login',params:{id:1}}" ><i class="iconfont icon-yonghu2"></i>立即登录</router-link>-->
      </div>

    </section>
    <LoginFooter></LoginFooter>
  </div>
</template>

<script>

  import LoginFooter from '../footer/login_footer.vue'
  export default {
    components:{
        LoginFooter
      },
  }
</script>
<style scoped>
 section{
   padding-top:0;
   margin: auto;
 }
</style>



// WEBPACK FOOTER //
// src/views/login/Index.vue